import React from 'react'
import { Card } from 'react-bootstrap'

export const TrainerCard = (props) => {
  const { trainer, acf_options } = props

  return (
    <div className="trainer-card">

      <div className="image-wrapper">
        <img src={trainer.image}/>
        <div className="trainer-circle" aria-hidden="true"></div>
        <div className="round-border" aria-hidden="true"></div>
      </div>
      <h3>{trainer.name}</h3>
      <p>
        {trainer.title}
      </p>
    </div>
  )
}
